import DefaultAvatarIcon from '@/assets/images/avatar.svg?react'

export function UserAvatar({ size }: { size: number }) {
  return <DefaultAvatarIcon width={size} height={size} />
}
